import { SlotEx, SlotData, SlotFruit } from "./slot_data";
import { SpriteHolderSlot } from "../sprite_holder_slot";
import SlotTableSound from "./slot_table_sound";

const { ccclass, property } = cc._decorator;


@ccclass
export class SlotCycleEvent extends cc.Component {

    slotData: SlotData
    spriteHoder: SpriteHolderSlot = null
    initEvent(data: SlotData, sp: SpriteHolderSlot) {
        this.slotData = data
        this.spriteHoder = sp
    }
    iconCycleOut(index: number, state: number) {
        let colmun = parseInt(this.node.name) - 1
        let iconStr
        let grid = this.slotData.slotEx[colmun].columnList[index - 1]
        if (state == 2) {
            iconStr = SlotData.serverSymbolToIcon(this.slotData.currentSlotResult.windowSymbols[index - 2].symbols[colmun])
        } else {
            let is = (this.slotData.curSlotIconIndex[colmun] + this.slotData.tempSlotIconIndex[colmun]) % this.slotData.lineCycleSequence[colmun].length
            this.slotData.tempSlotIconIndex[colmun] += 1
            iconStr = this.slotData.lineCycleSequence[colmun][is]
            if (state == 0) {
                if (grid.anim instanceof dragonBones.ArmatureDisplay && grid.anim.node != null) {
                    grid.icon.enabled = true
                    grid.anim.node.active = false
                }
            }
        }
        this.spriteHoder.setSprite(grid.icon, iconStr)
        this.spriteHoder.setSprite(grid.fuzzyIcon, `${iconStr}Fuzzy`)
    }

    cycleEnd() {
        let no = parseInt(this.node.name) - 1
        let s = this.rolloerHaveSpecialSound(no)
        let sp = this.slotData.cycleStatus == 3 && no == this.slotData.slotEx.length - 1
        if (sp) {
            SlotTableSound.playFreeSpinNone()
        } else if (s) {
            SlotTableSound.playSpecialIconSound()
        } else {
            SlotTableSound.playCycleStopSound(no + 1)
        }
        if (this.slotData.cycleStatus == 3) {
            if (no == this.slotData.startFreeEffectColumn) {
                SlotTableSound.stopSound(this.slotData.spinSoundId)
            }
        } else {
            if (no == 0) {
                SlotTableSound.stopSound(this.slotData.spinSoundId)
            }
        }
    }

    rolloerHaveSpecialSound(index) {
        for (let i = 0; i < this.slotData.currentSlotResult.windowSymbols.length; i++) {
            let sb = this.slotData.currentSlotResult.windowSymbols[i].symbols
            for (let j = 0; j < sb.length; j++) {
                let f = SlotData.serverSymbolToIcon(sb[j])
                if (f == SlotFruit.Free && index == j) {
                    if (SlotData.rewardFreeSpinTimes(this.slotData.currentSlotResult) > 0) {
                        return true
                    } else {
                        return index < 4
                    }
                }
            }
        }
        return false
    }
}
